<template>
  <IQOS :title="$t('integrations.poster_integration.title')">
    <!-- <div class="header c-white">
      <img class="poster-logo" src="https://dev.joinposter.com/img/poster-icon.png" alt />
      <h3>Poster</h3>
    </div> -->
    <div class="content">
      <p class="c-green">{{$t('integrations.poster_integration.working')}}</p>
      <p
        class="c-white"
      >{{$t('integrations.poster_integration.connected')}} {{ poster.created_at | formatDatetime }} {{$t('integrations.poster_integration.user')}} "{{ poster.user.name }}"</p>
      <div class="actions">
        <button
          class="square-button square-button-green"
          @click="onImportMenu"
          :disabled="busy"
        >{{$t('integrations.poster_integration.import_menu')}}</button>
        <button
          class="square-button square-button-green"
          @click="showImportWorkersUI"
          :disabled="busy"
        >{{$t('integrations.poster_integration.import_workers')}}</button>
        <button
          class="square-button square-button-green"
          @click="showImportTablesUI"
          :disabled="busy"
        >{{$t('integrations.poster_integration.import_halls')}}</button>
         <!-- <button
          class="square-button square-button-red"
          @click="showDestroyIntegrationUI"
          :disabled="busy"
        >{{$t('integrations.poster_integration.destroy_action')}}</button> -->
      </div>
    </div>

    <DangerConfirmModal
      @confirm="onImportWorkers"
      @cancel="askingImportWorkers = false"
      v-if="askingImportWorkers"
    >{{$t('integrations.poster_integration.warning_workers')}}</DangerConfirmModal>
    <DangerConfirmModal
      @confirm="onImportTables"
      @cancel="askingImportTables = false"
      v-if="askingImportTables"
    >{{$t('integrations.poster_integration.warning_halls')}}</DangerConfirmModal>
  </IQOS>
</template>

<script>
import PosterAPI from "@/api/poster";

export default {
  data() {
    return {
      askingImportWorkers: false,
      askingImportTables: false,
      importingMenu: false,
      busy: false
    };
  },
  methods: {
    onImportMenu() {
      this.busy = true;

      PosterAPI.importMenu()
        .then(ok => {
          this.busy = false;
          this.$store.dispatch("fetchCafe").finally(() => {
            this.$router.push("/menus");
          });
        })
        .catch(error => {
          this.busy = false;
          alert("Сталася помилка.");
        });
    },
    showImportWorkersUI() {
      this.askingImportWorkers = true;
    },
    showImportTablesUI() {
      this.askingImportTables = true;
    },
    onImportWorkers() {
      this.askingImportWorkers = false;
      this.busy = true;

      PosterAPI.importWorkers(this.cafe._id)
        .then(ok => {
          this.busy = false;
          this.$store.dispatch("fetchCafe").finally(() => {
            this.$router.push("/workers");
          });
        })
        .catch(error => {
          this.busy = false;
          alert("Сталася помилка.");
        });
    },
    onImportTables() {
      this.askingImportTables = false;
      this.busy = true;

      PosterAPI.importTables(this.cafe._id)
        .then(ok => {
          this.busy = false;
          this.$store.dispatch('fetchCafe').finally(() => {
            this.$router.push("/inside");
          });
          
        })
        .catch(error => {
          this.busy = false;
          alert("Сталася помилка.");
        });
    },
    showDestroyIntegrationUI() {

    }
  },
  computed: {
    poster() {
      return this.$store.state.cafe.poster;
    }
  }
};
</script>

<style scoped>
.poster-logo {
  width: auto;
  height: 5vh;
  margin-right: 1vh;
}

.header {
  display: flex;
}

.header h3 {
  position: relative;
 
  line-height: normal;
  font-size: 4vh;
}

p {
  margin: 0;
  font-size: 2vh;
  padding-top: 1.1vh;
}

.actions {
  margin-top: 1vh;
}

.square-button-green {
  width: 100%;
}

.square-button-red {
  width: 100%;
  border: 1px solid #e2223b;
  color: #e2223b;
}
</style>